// /src/core/branding.ts

export function setFavicon(href: string) {
  const id = "app-favicon";
  let link = document.getElementById(id) as HTMLLinkElement | null;

  if (!link) {
    link = document.createElement("link");
    link.id = id;
    link.rel = "icon";
    document.head.appendChild(link);
  }

  // Cache-bust so the browser actually swaps it
  const bust = `v=${Date.now()}`;
  const url = href.includes("?") ? `${href}&${bust}` : `${href}?${bust}`;
  link.href = url;
}

export function setAppleTouchIcon(href: string) {
  const id = "app-touchicon";
  let link = document.getElementById(id) as HTMLLinkElement | null;

  if (!link) {
    link = document.createElement("link");
    link.id = id;
    link.rel = "apple-touch-icon";
    document.head.appendChild(link);
  }

  link.href = href;
}
